import { render, staticRenderFns } from "./ContributionPublicField.vue?vue&type=template&id=28fe69ae&scoped=true&"
import script from "./ContributionPublicField.vue?vue&type=script&lang=js&"
export * from "./ContributionPublicField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fe69ae",
  null
  
)

export default component.exports